import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent, SimpleConfigBaseFilter } from 'gung-list';
import { MetadataService, Order, Product } from 'gung-standard';
import { JeevesOpenOrdersListTableConfigService } from 'gung-standard-jeeves';
import { CarLinerOpenOrdersTableComponent } from '../components/car-liner-open-orders-table/car-liner-open-orders-table.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerOpenOrderConfigService extends JeevesOpenOrdersListTableConfigService {
  getItems() {
    return super.getItems().pipe(
      map(orders => {
        return orders.filter(o => o.extra.oh.ordstat !== 90);
      })
    );
  }

  getFilters(): ConfigBaseFilter<Product>[] {
    const filters = super.getFilters();

    const index = filters.findIndex(filter => filter.getName() === 'ORDER_STATUS');
    if (index > -1) {
      filters.splice(index, 1, new CarLinerOrderStatusFilter(this.translationService, this.metadataService));
    }

    return filters;
  }

  getLayouts(): ListLayout<Order>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CarLinerOpenOrdersTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Product grid'
      }
    ];
  }
}

class CarLinerOrderStatusFilter extends SimpleConfigBaseFilter<Order> {
  constructor(protected translateService: TranslateService, protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'ORDER_STATUS';
  }

  getOptionIds(item: Order): string[] {
    if (item.extra.oh.ordstat < 13) {
      return ['ENTRY_IN_PROGRESS'];
    }
    if (item.extra.oh.ordstat === 13) {
      return ['ENTERED'];
    }
    if (item.extra.oh.ordstat >= 14 && item.extra.oh.ordstat <= 50) {
      return ['PICKING_IN_PROGRESS'];
    }
    if (item.extra.oh.ordstat === 70) {
      return ['INVOICED'];
    }

    return ['UNDEFINED'];
  }

  getOptionName(key: string): string {
    return this.translateService.instant(key);
  }
}